<template>
  <div class="filesControl">
    <div class="row" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <ul v-if="cellDisplayVal">
          <li v-for="file of cellDisplayVal" :key="file.key">
            <b-badge variant="success" :href="file.url" target="_blank">
              {{ file.name }}
              &nbsp;
              <a
                href="#"
                @click.stop.prevent="deleteFile(file.key, file.name)"
                class="data-grid__files _delete"
              >
                <icon v-if="!control.readonly" name="remove" style="vertical-align: -3px;" />
              </a>
            </b-badge>
          </li>
        </ul>
        <a href="#" v-if="!control.readonly" @click.prevent="showAddFilesModal">
          <icon name="cloud-upload" />
          <span>Upload</span>
        </a>
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <ul v-if="cellDisplayVal">
          <li v-for="file of cellDisplayVal" :key="file.key">
            <b-badge variant="success" :href="file.url" target="_blank">
              {{ file.name }}
              &nbsp;
              <a
                href="#"
                @click.stop.prevent="deleteFile(file.key, file.name)"
                class="data-grid__files _delete"
              >
                <icon v-if="!control.readonly" name="remove" style="vertical-align: -3px;" />
              </a>
            </b-badge>
          </li>
        </ul>
        <a href="#" v-if="!control.readonly" @click.prevent="showAddFilesModal">
          <icon name="cloud-upload" />
          <span>Upload</span>
        </a>
      </div>
    </div>
    <AddFilesModal
      ref="addFilesModal"
      :gridId="gridId"
      :rowKey="rowKey"
      :cellKey="cellKey"
      :options="options"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { pull as lodashPull } from 'lodash'
// components
import AddFilesModal from '@/components/DataGrid/modals/AddFiles'
// services
import db from '@/services/db'
import storage from '@/services/storage'

export default {
  props: ['control', 'labelPosition'],
  components: {
    AddFilesModal,
  },
  data() {
    return {
      gridId: null,
      rowKey: null,
      cellKey: null,
      options: null,
    }
  },
  computed: {
    ...mapState(['currentDash', 'dataGrid_options']),
    cellDisplayVal() {
      if (!this.gridId || !this.rowKey || !this.cellKey) return null

      return $dataGrid(this.gridId)[this.rowKey][`$${this.cellKey}$display`]
    },
  },
  methods: {
    showAddFilesModal() {
      this.$refs.addFilesModal.open()
    },
    deleteFile(key, name) {
      if (!confirm('Are you sure?')) return

      storage.delete(this.currentDash, `${key}_${name}`, async err => {
        if (err) return

        const curFileIds = this.control.value.split(',')
        const newFileIds = lodashPull(curFileIds, key)

        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value: newFileIds.join(',') || null,
        }

        await db.dataGrid.data.saveCellVal(data)

        db.files.delete(key)
      })
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[formBuilderInst.gridId]
    })
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.filesControl {
  ul {
    @include resetList;
    li {
      margin-bottom: 3px;
    }
  }
  &._delete:hover {
    color: #fb6340;
  }
}
</style>
